import { connect } from "react-redux";
import StrengthsGrowthMovement from "./StrengthsGrowthMovement";


const mapStateToProps = (state) => ({
    fetchTrendTopStrengthAndTopDevApi: state.BenchmarkFilteringReducer.fetchTrendTopStrengthAndTopDevApi

});

const mapDispatchToProps = (dispatch) => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(StrengthsGrowthMovement);
